<template>
  <form action="" @submit.prevent ref="form">
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                {{ headerText }}
            </p>
        </header>
        <section class="modal-card-body">
            <b-field label="Type">
              <b-select placeholder="Select type"
                required
                expanded
                v-model="entityType"
              >
                <option value="director">Director</option>
                <option value="representative">Representative</option>
                <option value="beneficiary">Ultimate beneficial individual owner</option>
                <optgroup label="Shareholder">
                  <option value="individual_shareholder">Individual Shareholder</option>
                  <option value="company">Holding Company</option>
                </optgroup>
                <optgroup label="Trust / Charity">
                  <option value="beneficiary">Beneficiary</option>
                  <option value="settlor">Settlor</option>
                  <option value="individual_trustee">Individual trustee</option>
                </optgroup>
              </b-select>
            </b-field>

            <b-field label="Name">
              <b-input type="text"
                v-model="name"
                required>
              </b-input>
            </b-field>

            <b-field label="Position" v-if="entityType === 'representative'">
              <b-input type="text"
                v-model="position"
                required>
              </b-input>
            </b-field>            

            <b-field label="Number of shares"
              v-if="['individual_shareholder', 'company'].indexOf(entityType) > -1"
            >
              <b-input type="number" min="0" max="100" step="0.01"
                placeholder="i.e. 49.99"
                v-model="sharesNumber"
                v-if="isSharesPercentage"
              />
              <b-input type="number" min="0"
                v-model="sharesNumber"
                v-else
              />

            </b-field>

            <shares-units
              v-model="isSharesPercentage"
              v-if="['individual_shareholder', 'company'].indexOf(entityType) > -1"
            />

            <div class="field"
              v-if="['individual_shareholder', 'company'].indexOf(entityType) > -1"
            >
              <b-checkbox v-model="isShareVoting">
                Is voting?
              </b-checkbox>
            </div>

            <b-field label="Relevant company">
              <b-select expanded required v-model="relevantCompany">
                <option
                  v-for="company in companies"
                  :key="company.name">{{company.name}}</option>
              </b-select>
            </b-field>

        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">Close</button>
          <button class="button is-primary" @click="addNewEntity">Add</button>
        </footer>
    </div>
  </form>
</template>

<script>
import SharesUnits from '@/components/SharesUnits'

export default {
  name: 'ModalAddEntity',
  props: [
    'companies',
    'kycId'
  ],
  components: {
    SharesUnits
  },
  computed: {
    headerText () {
      let header = 'Add new'
      if (!this.entityType) return `${header}...`
      if (['individual_shareholder', 'company'].indexOf(this.entityType) > -1) {
        return `${header} shareholder`
      }
      return `${header} ${this.entityType}`
    }
  },
  data () {
    return {
      entityType: null,
      name: null,
      position: null,
      sharesNumber: null,
      sharesPercentage: null,
      isShareVoting: true,
      isSharesPercentage: true,
      relevantCompany: null
    }
  },
  methods: {
    addNewEntity () {
      if (!this.$refs.form.checkValidity()) return
      const data = {
        'entityType': this.entityType,
        'entityName': this.name,
        'entityPosition': this.position,
        'sharesNumber': this.sharesNumber,
        'isSharesPercentage': this.isSharesPercentage,
        'isShareVoting': this.isShareVoting,
        'parentName': this.relevantCompany
      }
      this.axios.post(`/kyc/${this.kycId}/entity/add`, data)
        .then(response => {
          this.$parent.close()
          this.$toast.open({
            'message': 'Added successfully',
            'type': 'is-info'
          })
          // TODO: update parent data
          this.$emit('kyc-updated')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>

</style>
